import clsx from 'clsx';
import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { Author } from '../../interfaces/authors';
import NameList from '../NameList';
import TimeAgo from '../TimeAgo';

interface BylineProps {
  authors?: Author[];
  isRelatedArticle?: boolean;
  publishedAt?: string;
  withTooltip?: boolean;
}

const Byline = ({
  authors,
  isRelatedArticle = false,
  publishedAt,
  withTooltip = false,
}: BylineProps) => {
  return (
    <QueryClientProvider client={new QueryClient()}>
      <div
        className={clsx('font-suisse-screen text-black', {
          'text-byline-sm': !isRelatedArticle,
          'text-disclosure-sm': isRelatedArticle,
        })}
      >
        {authors?.length > 0 && (
          <div className="mr-10 inline-block">
            <NameList authors={authors} withTooltip={withTooltip} />
          </div>
        )}
        {publishedAt && <TimeAgo className="inline-block text-grayscale-gray" date={publishedAt} />}
      </div>
    </QueryClientProvider>
  );
};

export default Byline;
